import React, { memo, useCallback } from "react";
import "./UserCollectedData.css";
import Board from "@publicPortal/components/board/Board";
import ResponsiveAppBar from "@publicPortal/components/responsiveAppBar/ResponsiveAppBar";
import { Box, Tabs, Tab } from "@mui/material";
import SavedSearchesTab from "./savedSearchesTab/SavedSearchesTab";
import NotificationsTab from "./notificationsTab/NotificationsTab";
import TrackedApplicationsTab from "./trackedTab/TrackedApplicationsTab";
import { useUserCollectedDataTabsStore, UserDataTabNames } from "@publicPortal/store/store";
import { useDeviceDetect } from "@mirage/hooks/useDeviceDetect";
import { MobileTabPicker } from "@publicPortal/components/mobileTabPicker/MobileTabPicker";

type UserDataTabNamesTypes = keyof typeof UserDataTabNames;

const UserCollectedData = memo(() => {
    const currentTab = useUserCollectedDataTabsStore((s) => s.userCollectedDataTab);
    const changeTab = useUserCollectedDataTabsStore((s) => s.setUserCollectedDataTab);
    const { isMobile } = useDeviceDetect();
    const tabs: UserDataTabNamesTypes[] = ["My Searches", "My Notifications", "My Tracks"];
    const onTabChange = (event: React.SyntheticEvent, newTab: UserDataTabNames) => {
        changeTab(newTab);
    };
    const onTabSelect = useCallback((newTab: string) => changeTab(newTab as any), [changeTab]);

    return (
        <>
            <ResponsiveAppBar />
            <Board size="big">
                <Box className="collected-data-board-content">
                    {isMobile ? (
                        <MobileTabPicker label="Current Tab" currentTab={currentTab} tabs={tabs} onTabSelect={onTabSelect} />
                    ) : (
                        <Tabs value={currentTab} onChange={onTabChange} aria-label="user-collected-data-navigation-tabs" centered={true} className="collected-data-tabs">
                            <Tab disableRipple label="My Searches" value={"My Searches"} />
                            <Tab disableRipple label="My Notifications" value={"My Notifications"} />
                            <Tab disableRipple label="My Tracks" value={"My Tracks"} />
                        </Tabs>
                    )}
                    {getTabContent()}
                </Box>
            </Board>
        </>
    );

    function getTabContent() {
        switch (currentTab) {
            case UserDataTabNames["My Searches"]:
                return <SavedSearchesTab />;
            case UserDataTabNames["My Notifications"]:
                return <NotificationsTab />;
            case UserDataTabNames["My Tracks"]:
                return <TrackedApplicationsTab />;
            default:
                throw Error(`Wrong Tab Name on getTabContent - ${currentTab}`);
        }
    }
});

export default UserCollectedData;
